import axios from "axios";

//API DESTE PROJETO - MONITORAMENTO
export const projectApi = axios.create({
  //baseURL: "http://192.168.56.1:3002",
  //baseURL: "http://192.168.14.101:3002",
  baseURL: "http://192.168.0.11:3002",
  //baseURL: "https://distribuidorpalmares.no-ip.info/api",
});

//API ROTEAMENTO
export const routingApi = axios.create({
  baseURL: "http://192.168.0.11:3010",
  //baseURL: "http://192.168.14.101:3010",
});

export default projectApi;
